import { apiClient } from "@alaffia-technology-solutions/client-sdk-react-query";
import { toast } from "@alaffia-technology-solutions/ds";

export function useCreateMessageThread() {
  const getThreadsCtx = apiClient.cases.getThreads.useQueryContext();

  return apiClient.cases.createThread.useMutation({
    onSuccess: async (_data, { caseId }) => {
      toast.success("Success", {
        description: "Thread created successfully",
      });
      return getThreadsCtx.invalidate({
        input: {
          caseId,
        },
      });
    },
  });
}
